import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { IhmPipesModule } from './../../shared/pipes/ihm-pipes.module';
import { IhmPickListComponent } from './ihm-pick-list.component';

@NgModule({
  imports: [
    CommonModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatListModule,
    MatIconModule,
    MatTooltipModule,
    IhmPipesModule,

    VirtualScrollerModule
  ],
  declarations: [IhmPickListComponent],
  exports: [IhmPickListComponent]
})
export class IhmPickListModule {}
